import { render, staticRenderFns } from "./message-details-schedule-block.vue?vue&type=template&id=2084ac7c&scoped=true&"
import script from "./message-details-schedule-block.vue?vue&type=script&lang=js&"
export * from "./message-details-schedule-block.vue?vue&type=script&lang=js&"
import style0 from "./message-details-schedule-block.vue?vue&type=style&index=0&id=2084ac7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084ac7c",
  null
  
)

export default component.exports